// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7ef17274","455":"ed3d0504","644":"0ff6491a"}[chunkId] + ".chunk.js";
};